module.exports = __webpack_public_path__ + "img/banner-supplies-mapgrafiOld.7b44e793.jpg";